import React from "react";
import { Scissors, Shirt, Boxes, ArrowRight } from "lucide-react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="flex flex-col justify-center px-8 sm:px-16 py-12 bg-white">
        <div className="max-w-md w-full mx-auto">
          <div className="flex items-center gap-2 mb-10">
            <div className="h-10 w-10 rounded-lg bg-blue-800 text-white grid place-items-center font-head font-extrabold">A</div>
            <div>
              <p className="font-head font-extrabold text-lg text-slate-900 leading-none">ASV Apparels</p>
              <p className="text-xs text-slate-500">Garment Production ERP</p>
            </div>
          </div>
          <h1 className="text-3xl font-bold text-slate-900 font-head">Factory floor to finished goods, fully traced.</h1>
          <p className="text-slate-500 mt-3 text-sm leading-relaxed">
            Manage fabric purchasing, lots, cutting, jobber challans, WIP, accessories and finished goods — with complete lot-to-garment traceability.
          </p>
          <button
            data-testid="google-login-btn"
            onClick={handleLogin}
            className="mt-8 w-full inline-flex items-center justify-center gap-3 rounded-lg bg-blue-800 text-white py-3 font-medium hover:bg-blue-900 transition-colors shadow-sm"
          >
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" className="h-5 w-5 bg-white rounded" alt="" />
            Continue with Google
            <ArrowRight size={16} />
          </button>
          <p className="text-xs text-slate-400 mt-4">Sign in with your authorised factory account.</p>
        </div>
      </div>
      <div className="hidden lg:flex flex-col justify-center bg-slate-900 text-white px-16 relative overflow-hidden">
        <div className="relative z-10 space-y-8 max-w-md">
          {[
            { icon: Boxes, t: "Fabric & Lot Control", d: "Every meter tracked from PO to lot balance." },
            { icon: Scissors, t: "Production & Jobber Flow", d: "Cutting, challans, shortages and WIP across 12 stages." },
            { icon: Shirt, t: "Finished Goods & Reports", d: "Size-wise output, accessory consumption and 20 reports." },
          ].map((f, i) => (
            <div key={i} className="flex gap-4 animate-fadein" style={{ animationDelay: `${i * 120}ms` }}>
              <div className="h-11 w-11 rounded-lg bg-blue-800/40 border border-blue-700 grid place-items-center shrink-0">
                <f.icon size={20} className="text-blue-200" />
              </div>
              <div>
                <p className="font-semibold font-head">{f.t}</p>
                <p className="text-sm text-slate-400 mt-0.5">{f.d}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="absolute -bottom-24 -right-24 h-96 w-96 rounded-full bg-blue-800/20 blur-3xl" />
      </div>
    </div>
  );
}
